<template>
    <router-link
        :class="[mobile ? 'router-link router-link-mobile text-base' : 'router-link router-link-desktop text-base', itemClass, isCollapsed ? 'router-link-collapsed' : '', isAlternateRouteActive ? 'router-link-active' : '']"
        :to="to"
        :exact="exact"
        :title="isCollapsed ? label : null"
        :aria-label="isCollapsed ? label : null"
        :aria-current="isAlternateRouteActive ? 'page' : null"
    >
        <span :class="['menu-link-icon-slot', isCollapsed ? 'menu-link-icon-slot-collapsed' : '']">
            <svg-vue
                :icon="icon"
                :class="resolvedIconClass"
            ></svg-vue>
        </span>
        <span :class="['menu-link-label', isCollapsed ? 'menu-link-label-hidden' : '']">{{ label }}</span>
        <span
            v-if="badgeVisible && !isCollapsed"
            class="menu-link-badge menu-link-badge-fade-in"
        >
            {{ formattedBadgeCount }}
        </span>
    </router-link>
</template>

<script>
export default {
    name: "menu-item",
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
        collapsed: {
            type: Boolean,
            default: false,
        },
        to: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: true,
        },
        iconClass: {
            type: String,
            required: false,
            default: null,
        },
        activeRoutes: {
            type: Array,
            required: false,
            default: () => [],
        },
        label: {
            type: String,
            required: true,
        },
        exact: {
            type: Boolean,
            required: false,
            default: false,
        },
        itemClass: {
            type: String,
            required: false,
            default: '',
        },
        badgeVisible: {
            type: Boolean,
            required: false,
            default: false,
        },
        badgeCount: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    computed: {
        isCollapsed() {
            return !this.mobile && this.collapsed;
        },
        isAlternateRouteActive() {
            const currentPath = String(this.$route?.path || '');

            return this.activeRoutes.some((route) => {
                const normalizedRoute = String(route || '').replace(/\/$/, '');
                return normalizedRoute !== ''
                    && (currentPath === normalizedRoute || currentPath.startsWith(normalizedRoute + '/'));
            });
        },
        resolvedIconClass() {
            if (this.iconClass) {
                return 'stage-menu-icon ' + this.iconClass;
            }

            return 'stage-menu-icon main-menu-icon-size text-gray-400 transition ease-in-out duration-200';
        },
        formattedBadgeCount() {
            const normalizedCount = Math.max(0, Number(this.badgeCount || 0));
            if (normalizedCount > 99) {
                return '99+';
            }

            return String(normalizedCount);
        },
    },
}
</script>
